export default __webpack_public_path__ + "static/media/rating_0.23d3ccc5.png";